import { render, staticRenderFns } from "./EditPageDetailsIcon.vue?vue&type=template&id=2e399147&"
import script from "./EditPageDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports